
import { IGetCentroCustoDropDownUseCase } from "../../../presentation/useCases/read/get_centro_custo_dropdown_use_case";
import { CentroCustoDropDown } from "../../models/centro_custo_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetCentroCustoDropDownUseCase
 */

export class GetCentroCustoDropDownUseCase implements IGetCentroCustoDropDownUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getCentroCustoDropDown(IdContrato?: number | null): Promise<CentroCustoDropDown[]> {
    const response = this.repository.getCentroCustoDropDown(IdContrato);
    return response;
  }
}